
/* all routes */
const GideLayout = () => import("../layouts/GideLayout.vue")
const ContentLayout = () => import("../layouts/ContentLayout.vue")
const QuizLayout = () => import("../layouts/QuizLayout.vue")
const WebflowLayout = () => import("../layouts/WeflowLayout.vue") // To be Used on the website
const WebflowLayoutHeaderFooter = () => import("../layouts/WebflowLayoutHeaderFooter.vue") // Has Header Footer from gide.ai
const BlankLayout = () => import("../layouts/BlankLayout.vue") // no header or footer

const LoginV1 = () => import("../views/LoginV1.vue")
const RegisterV1 = () => import("../views/RegisterV1.vue")
const ActivateV1 = () => import("../views/ActivateV1.vue")
const QuickProfileV1 = () => import("../views/QuickProfileV1.vue")
const ForgotPasswordV1 = () => import("../views/ForgotPasswordV1.vue")
const ResetPasswordV1 = () => import("../views/ResetPasswordV1.vue")

const Posts = () => import("../views/Gide/Post/Posts.vue")
const PostDetail = () => import("../views/Gide/Post/PostDetail.vue")
const Clubs = () => import("../views/Gide/ListPages/Club/ClubList.vue")
const UserProfile = () => import("../views/Gide/Profile/User/Profile.vue")
const UserPublicProfile = () => import("../views/Gide/Profile/User/PublicProfile.vue")
const UserProfileEdit = () => import("../views/Gide/Profile/User/ProfileEdit.vue")
const ClubProfile = () => import("../views/Gide/Profile/Club/Profile.vue")
const ClubProfileEdit = () => import("../views/Gide/Profile/Club/ProfileEdit.vue")
const ClubCreate = () => import("../views/Gide/Profile/Club/ProfileAdd.vue")
const eventView = () => import("../views/Gide/Event/EventView.vue")
const eventAdd = () => import("../views/Gide/Event/EventAdd.vue")
const eventEdit = () => import("../views/Gide/Event/EventEdit.vue")
const Events = () => import("../views/Gide/Event/EventList.vue")

const OrganisationList = () => import("../views/Gide/Organisation/OrganisationList.vue")
const OrganisationDetails = () => import("../views/Gide/Organisation/OrganisationDetails.vue")
const OrganisationEdit = () => import("../views/Gide/Organisation/OrganisationEdit.vue")
const OrganisationPublicProfile = () => import("../views/Gide/Organisation/OrganisationPublicProfile.vue")

const CourseFinder = () => import("../views/Gide/Organisation/CourseFinder.vue")

const SubscriptionPlans = () => import("../views/Gide/Subscription/SubscriptionPlans.vue")

// Paygw_status
const PaygwStatus = () => import ("../views/Gide/Paygw/Paygw_status.vue")
const Paygw = () => import ("../views/Gide/Paygw/Paygw.vue")

const Invoice = () => import ("../views/Invoice.vue")

// Content page
const PostContent = () => import("../views/Content/PostContent.vue")
const Tnc = () => import("../views/Tnc.vue")
const PrivacyPolicy = () => import("../views/PrivacyPolicy.vue")

// Public Pages
const ErrorPage = () => import("../views/Public/ErrorPage.vue")
const GideEventList = () => import("../views/Public/GideEventList.vue")
const GideEventView = () => import("../views/Public/GideEventView.vue")
const GideViewCurrentEvent = () => import("../views/Public/GideViewCurrentEvent.vue")
const WebFlowContactUsStudentsAdd = () => import("../views/Public/WebFlowContactUs.vue") // B2C leads Regsitration no header
const WebFlowContactUsStudentsAddV2 = () => import("../views/Public/WebFlowContactUsV2.vue") // B2C leads Regsitration with website header
const CustomActivityForm = () => import("../views/Public/CustomActivityForm.vue")

// photos and videos
const Photos = () => import("../views/Gide/Photos.vue")

const Admission = () => import("../components/Admission.vue")

// Admssion Analytics DashBoard
const AdmissionDashboard = () => import("../views/Gide/ListPages/Admission/AdmissionDashboard.vue")
const AdmissionAnalyticsSchoolWise = () => import("../views/Gide/ListPages/Analytics/AdmissionAnalyticsSchoolWise.vue")

// Event Dashboard Report
const EventList = () => import("../components/EventList.vue")

// Report Dashboard
const EventParticipantReport = () => import("../views/Gide/Event/EventParticipantReport.vue")
const EventReportSchoolWise = () => import("../views/Gide/Event/EventReportSchoolWise.vue")

// Organisation
const OrganisationAdd = () => import("../views/Gide/Organisation/OrganisationAdd.vue")
const orgAccountDashboard = () => import("../components/OrgDashboard.vue") // If a user is a univ agent or a organisation management with multiple organisations or univs or combo under its account then show the list
const OrgModeration = () => import ("../views/Gide/Organisation/OrgModeration.vue")
const OrgSaasDashboard = () => import ("../views/Gide/Organisation/OrgSaasDashboard.vue")
const OrgSaasTaxDocuments = () => import ("../views/Gide/Organisation/OrgSaasTaxDocuments.vue")
const OrgSaasDomainValidate = () => import ("../views/Gide/Organisation/OrgSaasDomainValidate.vue")
const OrgSaasOrganisationEdit = () => import ("../views/Gide/Organisation/OrgSaasOrganisationEdit.vue")
const OrgSaasLoginPagePreview = () => import ("../views/Gide/Organisation/OrgSaasLoginPagePreview.vue")
const OrgSaasRevenueDashboard = () => import ("../views/Gide/Organisation/OrgSaasRevenueDashboard.vue")
const OrgSaasRedemptionDashboard = () => import ("../views/Gide/Organisation/OrgSaasRedemption/OrgSaasRedemptionDashboard.vue")
const OrgSaasRedemptionAdminDashboard = () => import ("../views/Gide/Organisation/OrgSaasRedemption/OrgSaasRedemptionAdminDashboard.vue")
const OrgProfileList = () => import("../views/Gide/Organisation/OrgProfile/OrgProfileList.vue")

// Roles(ACL)
const ManageUsers = () => import ("../components/Roles/ManageUsers.vue")
const ManageRoles = () => import ("../views/Gide/Role/RoleList.vue")

// Affiliate linked on org edit screen
const AffiliateList = () => import("../views/Gide/Affiliate/AffiliateList.vue")

// Follower Reports
const analyticsFollowerCountReport = () => import("../views/Gide/ListPages/Analytics/analyticsFollowerCountReport.vue") // To be displayed to GIDE ADMIN ONLY
const analyticsFollowerListReport = () => import("../views/Gide/ListPages/Analytics/analyticsFollowerListReport.vue") // To be displayed to UNIV ADMIN ONLY

const Confirmation = () => import("../views/Confirmation.vue")

// Organisation Subscription Report
const SubscriptionReport = () => import("../views/Gide/Subscription/SubscriptionReport.vue")

// Event Checkin Report
const EventCheckinReport = () => import("../views/Gide/Event/EventCheckinReport.vue")
const EventCheckingForStudent = () => import("../views/Gide/Event/EventCheckingForStudent.vue")

// Questions
const QuestionQuizFullPageV1 = () => import("../views/Gide/Quiz/QuestionQuizFullPageV1.vue")
const QuestionQuizFullPage = () => import("../views/Gide/Quiz/QuestionQuizFullPage.vue")

const QuizList = () => import("../views/Gide/Quiz/QuizList.vue")
const AppChains = () => import("../views/Gide/Quiz/AppChains.vue")
const QuizResultView = () => import("../views/Gide/Quiz/QuizResultView.vue")
const QuizReportCardView = () => import("../views/Gide/Quiz/QuizReportCardView.vue")

const QuizDetail = () => import("../views/Gide/Quiz/QuizDetail.vue")
const QuizBreakTimer = () => import("../views/Gide/Quiz/QuizBreakTimer.vue")
const AppAnswerExplanation = () => import("../components/AppAnswerExplanation.vue")
const AnswerAnalysis = () => import("../components/AnswerAnalysis.vue")
const Analytics = () => import("../views/Gide/Quiz/Analytics.vue")

// Games
const hangman = () => import("../views/Gide/Games/HangmanGames/Hangman.vue")
const crossword = () => import("../views/Gide/Games/CrossWordGames/Crossword.vue")

// SPCM
const SpcmView = () => import("../views/Gide/SPCM/SpcmView.vue")
const SpcmView1 = () => import("../views/Gide/SPCM/SpcmViewV1.vue")
const SpcmList = () => import("../views/Gide/SPCM/SpcmList.vue")
const SpcmListv1 = () => import("../views/Gide/SPCM/SpcmListV1.vue")
const SpcmProduct = () => import("../views/Gide/SPCM/SpcmProduct.vue")

// Test Prep
const TSeriesProductList = () => import("../views/Gide/TPrep/TSeriesProductList.vue")
const TPrepModuleList = () => import("../views/Gide/TPrep/TPrepModuleList.vue")
const TPrepAttemptList = () => import("../views/Gide/TPrep/TPrepAttemptList.vue")
const TPrepSpecificProduct = () => import("../views/Gide/TPrep/TPrepSpecificProduct.vue")

// TprepSession
const TprepAdminDashboard = () => import("../views/Gide/TPrep/TprepAdminDashboard.vue")
const TprepSessionAdd = () => import("../views/Gide/TPrep/TprepSessionAdd.vue")
const TprepSessionEdit = () => import("../views/Gide/TPrep/TprepSessionEdit.vue")

// Tprep Quiz Dashboard
const TprepQuizDashboard = () => import("../views/Gide/TPrep/TprepQuizDashboard.vue")

// Tprep QuBatch Configuration
const TprepBatchList = () => import("../views/Gide/TprepBatch/TprepBatchList.vue")

// Analytics
const analyticsTrackerList = () => import("../views/Gide/ListPages/Analytics/analyticsTrackerList.vue")
const clickAnalytics = () => import("../views/Gide/ListPages/Analytics/ClickAnalytics.vue")

// Test Prep Config
const TPrepSubjectModuleList = () => import("../views/Gide/TPrepSubjectModule/TPrepSubjectModuleList.vue")
const TPrepSubjectModuleAdd = () => import("../views/Gide/TPrepSubjectModule/TPrepSubjectModuleAdd.vue")
const TPrepSubjectModuleEdit = () => import("../views/Gide/TPrepSubjectModule/TPrepSubjectModuleEdit.vue")

// Interest
const InterestList = () => import("../views/Gide/Interest/InterestList.vue")
const InterestAdd = () => import("../views/Gide/Interest/InterestAdd.vue")
const InterestEdit = () => import("../views/Gide/Interest/InterestEdit.vue")

// Interest Category
const InterestCategoryList = () => import("../views/Gide/Interest/InterestCategoryList.vue")
const InterestCategoryAdd = () => import("../views/Gide/Interest/InterestCategoryAdd.vue")
const InterestCategoryEdit = () => import("../views/Gide/Interest/InterestCategoryEdit.vue")

// Question Bank
const QuizBankList = () => import("../views/Gide/QuizBank/QuizBankList.vue")
const QuizBankAdd = () => import("../views/Gide/QuizBank/QuizBankAdd.vue")
const QuizBankEdit = () => import("../views/Gide/QuizBank/QuizBankEdit.vue")
const QuestionQuizView = () => import("../views/Gide/QuizBank/QuestionQuizView.vue")
const AppResultList = () => import("../views/Gide/AppResult/AppResultList.vue")
const AppResultListFix = () => import("../views/Gide/AppResult/AppResultListFix.vue")

const AppEdit = () => import("../views/Gide/Apps/AppEdit.vue")
const AppList = () => import("../views/Gide/Apps/AppList.vue")
const AppAdd = () => import("../views/Gide/Apps/AppAdd.vue")
const ThankYouPage = () => import("../views/Gide/ThankYouPage.vue")

// Event
const eventList = () => import("../components/EventList.vue")

// University Courses
const UniversityCourseList = () => import("../views/Gide/ListPages/University Courses/UniversityCourseList.vue")
const UniversityCourseAdd = () => import("../views/Gide/ListPages/University Courses/UniversityCourseAdd.vue")
const UniversityCourseEdit = () => import("../views/Gide/ListPages/University Courses/UniversityCourseEdit.vue")
const UniversityCourseDashboard = () => import("../views/Gide/ListPages/University Courses/UniversityCourseDashboard.vue")

// SPCM Calender
const SpcmCalenderList = () => import("../views/Gide/SPCM/SpcmCalenderList.vue")
const SpcmCalenderEdit = () => import("../views/Gide/SPCM/SpcmCalenderEdit.vue")
const SpcmCalenderAdd = () => import("../views/Gide/SPCM/SpcmCalenderAdd.vue")
// const SpcmCalenderEdit = () => import("../views/Admin/Spcm/SpcmCalenderEdit.vue")
const SpcmCalendarCategoryList = () => import("../views/Gide/SPCM/SpcmCalendarCategoryList.vue")

const spcmMilestonesList = () => import("../views/Gide/SPCM/SpcmMilestonesList.vue")
const spcmMilestonesAdd = () => import("../views/Gide/SPCM/SpcmMilestonesAdd.vue")
const spcmMilestonesEdit = () => import("../views/Gide/SPCM/SpcmMilestonesEdit.vue")

// Gpaths
const GPathDashboardV1 = () => import("../views/Gide/GPath/GPathWorkflowV1.1.vue")

const GPathProductPage = () => import("../views/Gide/GPath/GPathProductPage.vue")
const GPathProductList = () => import("../views/Gide/GPath/GPathProductList.vue")
const GPathReportGenerate = () => import("../views/Gide/GPath/GPathReportGenerate.vue")

// GPaths Roadmap
const GpathRoadmapList = () => import("../views/Gide/GPath/GpathRoadmapList.vue")
const GpathRoadmapAdd = () => import("../views/Gide/GPath/GpathRoadmapAdd.vue")
const GpathRoadmapEdit = () => import("../views/Gide/GPath/GpathRoadmapEdit.vue")

// GPaths Careerr
const GPathCareerList = () => import("../views/Gide/GPath/GPathCareerList.vue")
const GPathCareerAdd = () => import("../views/Gide/GPath/GPathCareerAdd.vue")
const GPathCareerEdit = () => import("../views/Gide/GPath/GPathCareerEdit.vue")

// GPaths Aptitude
const GPathAptitudeList = () => import("../views/Gide/GPath/GPathAptitudeList.vue")
const GPathAptitudeAdd = () => import("../views/Gide/GPath/GPathAptitudeAdd.vue")
const GPathAptitudeEdit = () => import("../views/Gide/GPath/GPathAptitudeEdit.vue")

// GPaths Career Inter
const GPathCareerInterList = () => import("../views/Gide/GPath/GPathCareerInterList.vue")
const GPathCareerInterAdd = () => import("../views/Gide/GPath/GPathCareerInterAdd.vue")
const GPathCareerInterEdit = () => import("../views/Gide/GPath/GPathCareerInterEdit.vue")

// GPaths Skill
const GPathSkillEdit = () => import("../views/Gide/GPath/GPathSkillEdit.vue")
const GPathSkillList = () => import("../views/Gide/GPath/GPathSkillList.vue")
const GPathSkillAdd = () => import("../views/Gide/GPath/GPathSkillAdd.vue")

// GPaths Career Type/Role List
const GPathCareerTypeList = () => import("../views/Gide/GPath/GPathCareerTypeList.vue")
const GPathCareerRoleList = () => import("../views/Gide/GPath/GPathCareerRoleList.vue")
const GPathCareerRoleDetail = () => import("../views/Gide/GPath/GPathCareerRoleDetail.vue")

// GPaths Career Univ List
const GPathCareerUnivList = () => import("../views/Gide/GPath/GPathCareerUnivList.vue")
const GPathCareerUnivAdd = () => import("../views/Gide/GPath/GPathCareerUnivAdd.vue")
const GPathCareerUnivEdit = () => import("../views/Gide/GPath/GPathCareerUnivEdit.vue")

// GPATH SESSION
const GPathSessionList = () => import("../views/Gide/GPath/GPathSessionList.vue")
const GPathConfigList = () => import("../views/Gide/GPath/GPathConfigList.vue")
const GPathSchoolDashboard = () => import("../views/Gide/GPath/GPathSchoolDashboard.vue")
const GPathSessionAffiliateList = () => import("../views/Gide/GPath/GPathSessionAffiliateList.vue")

// Invite User
const InviteUser = () => import("../components/InviteUser.vue")
const InviteUserV1 = () => import("../components/InviteUserV1.vue")

// GPATH ROADMAP EXTRA
const GPathrRoadmapExtraList = () => import("../views/Gide/GPath/GPathrRoadmapExtraList.vue")
const GPathrRoadmapExtraAdd = () => import("../views/Gide/GPath/GPathrRoadmapExtraAdd.vue")
const GPathrRoadmapExtraEdit = () => import("../views/Gide/GPath/GPathrRoadmapExtraEdit.vue")

// GPath Career Univ Scholarship List
const GPathCareerUnivScholarshipList = () => import("../views/Gide/GPath/GPathCareerUnivScholarshipList.vue")
const GPathCareerUnivScholarshipAdd = () => import("../views/Gide/GPath/GPathCareerUnivScholarshipAdd.vue")
const GPathCareerUnivScholarshipEdit = () => import("../views/Gide/GPath/GPathCareerUnivScholarshipEdit.vue")

// GPath Aptitude Reco
const gpathAptitudeRecoList = () => import("../views/Gide/GPath/GpathAptitudeRecoList.vue")
const gpathAptitudeRecoAdd = () => import("../views/Gide/GPath/GpathAptitudeRecoAdd.vue")
const gpathAptitudeRecoEdit = () => import("../views/Gide/GPath/GpathAptitudeRecoEdit.vue")

// GPath Skill Reco
const gpathSkillRecoList = () => import("../views/Gide/GPath/GpathSkillRecoList.vue")
const gpathSkillRecoAdd = () => import("../views/Gide/GPath/GpathSkillRecoAdd.vue")
const gpathSkillRecoEdit = () => import("../views/Gide/GPath/GpathSkillRecoEdit.vue")

// GPath Company Reco
const GpathCompanyList = () => import("../views/Gide/GPath/GpathCompanyList.vue")

// RESUME
const ResumeBuild = () => import("../views/Gide/Resume/ResumeBuild.vue")
const Resume = () => import("../views/Gide/Resume/Resume.vue")

// Mesh
const MeshInvite = () => import("../views/Gide/MeshInvite.vue")
const MeshDeepLink = () => import("../views/Gide/MeshDeepLink.vue")

// CustomReport - Custom Downloadable Reports
const CustomReportList = () => import("../views/Gide/CustomReport/CustomReportList.vue")

// Config Menu List
const ConfigMenuList = () => import("../views/Gide/ConfigMenu/ConfigMenuList.vue")
const ConfigMenuAdd = () => import("../views/Gide/ConfigMenu/ConfigMenuAdd.vue")
const ConfigMenuEdit = () => import("../views/Gide/ConfigMenu/ConfigMenuEdit.vue")

// user
const UserList = () => import("../views/Gide/User/UserList.vue")
const UserSearch = () => import("../views/Gide/User/UserSearch.vue")

// subscription Plans
const SubscriptionPlanList = () => import("../views/Gide/Subscription/SubscriptionPlanList.vue")
const SubscriptionPlanAdd = () => import("../views/Gide/Subscription/SubscriptionPlanAdd.vue")
const SubscriptionPlanEdit = () => import("../views/Gide/Subscription/SubscriptionPlanEdit.vue")

// Subscriptions
const SubscriptionList = () => import("../views/Gide/Subscription/SubscriptionList.vue")
const SubscriptionAdd = () => import("../views/Gide/Subscription/SubscriptionAdd.vue")
const SubscriptionEdit = () => import("../views/Gide/Subscription/SubscriptionEdit.vue")

// PayTransactions
const PayTransactionsListAdmin = () => import("../views/Gide/PayTransactions/PayTransactionsList.vue")
const PayTransactionsEdit = () => import("../views/Gide/PayTransactions/PayTransactionsEdit.vue")
const MyBillingHistory = () => import("../views/Gide/PayTransactions/MyBillingHistory.vue")

// Contact us Form List for Parent/ Student
const ContactUsList = () => import("../views/Gide/ContactUs/contactusList.vue")

// B2B User lead registration
const contactusB2BList = () => import("../views/Gide/ContactUs/contactusB2BList.vue")

// Admin Notification
const AdminNotificationList = () => import("../views/Gide/AdminNotification/AdminNotificationList.vue")
const AdminNotificationAdd = () => import("../views/Gide/AdminNotification/AdminNotificationAdd.vue")
const AdminNotificationEdit = () => import("../views/Gide/AdminNotification/AdminNotificationEdit.vue")

// Admin Faq
const AdminFaqList = () => import("../views/Gide/AdminFaq/AdminFaqList.vue")
const AdminFaqAdd = () => import("../views/Gide/AdminFaq/AdminFaqAdd.vue")
const AdminFaqEdit = () => import("../views/Gide/AdminFaq/AdminFaqEdit.vue")

// Blog
const blogList = () => import("../views/Gide/Blog/blogList.vue")
const blogEdit = () => import("../views/Gide/Blog/blogEdit.vue")
const blogPublicList = () => import("../views/Public/GideBlogList.vue")
const blogView = () => import("../views/Public/GideBlogView.vue")

// Chat Bot Data Source
const ChatBotDataSrcList = () => import("../views/Gide/ChatBotDataSrc/ChatBotDataSrcList.vue")
const ChatBotDataSrcAdd = () => import("../views/Gide/ChatBotDataSrc/ChatBotDataSrcAdd.vue")
const ChatBotDataSrcEdit = () => import("../views/Gide/ChatBotDataSrc/ChatBotDataSrcEdit.vue")

// Chat Bot LLM
const ChatBotLLMList = () => import("../views/Gide/ChatBotLLM/ChatBotLLMList.vue")
const ChatBotLLMAdd = () => import("../views/Gide/ChatBotLLM/ChatBotLLMAdd.vue")
const ChatBotLLMEdit = () => import("../views/Gide/ChatBotLLM/ChatBotLLMEdit.vue")

// CustomForm
const CustomFormFieldsList = () => import("../views/Gide/CustomForm/CustomFormFieldsList.vue")
const CustomFormFieldsAdd = () => import("../views/Gide/CustomForm/CustomFormFieldsAdd.vue")
const CustomFormFieldsEdit = () => import("../views/Gide/CustomForm/CustomFormFieldsEdit.vue")

const CustomFormBuildList = () => import("../views/Gide/CustomForm/customFormBuildList.vue")
const customFormBuildEdit = () => import("../views/Gide/CustomForm/customFormBuildEdit.vue")

// Resource Pages
const ResourceScholarships = () => import("../views/Gide/Resources/ResourceScholarships.vue")
const ResourceGidePreneur = () => import("../views/Gide/Resources/ResourceGidePreneur.vue")

const UdfActionList = () => import("../views/Gide/Udf/UdfActionList.vue")
const UdfActionAdd = () => import("../views/Gide/Udf/UdfActionAdd.vue")
const UdfActionEdit = () => import("../views/Gide/Udf/UdfActionEdit.vue")

// User Bill Details List
const UserBillDetailsList = () => import("../views/Gide/UserBillDetails/UserBillDetailsList.vue")
const UserBillDetailsAdd = () => import("../views/Gide/UserBillDetails/UserBillDetailsAdd.vue")
const UserBillDetailsEdit = () => import("../views/Gide/UserBillDetails/UserBillDetailsEdit.vue")

// Spcm Fire flies
const SPCMFireFliesList = () => import("../views/Admin/Spcm/SPCMFirefliesList.vue")
const SPCMFireFliesView = () => import("../views/Admin/Spcm/SPCMFirefliesView.vue")

// Spcm Cpunsellor list
const SpcmCounsellorAdd = () => import("../views/Gide/SPCM/SpcmCounsellorAdd.vue")
const SpcmCounsellorEdit = () => import("../views/Gide/SPCM/SpcmCounsellorEdit.vue")
const SpcmStudentCounsellorTeam = () => import("../views/Gide/SPCM/SpcmStudentCounsellorTeam.vue")

// spcm Manage Team
const SpcmManageTeam = () => import("../views/Gide/SPCM/SpcmCounsellorEdit.vue")

// spcm Essay Editor
const SpcmEssayEditor = () => import("../views/Gide/SPCM/SpcmEssayEditor.vue")

// spcm Univ List
const SpcmUnivList = () => import("../views/Gide/SPCM/SpcmUnivList.vue")

// spcm analytics
const SpcmAnalyticsCaseSummary = () => import("../views/Gide/SPCM/SpcmAnalyticsCaseSummary.vue")
const SpcmAnalyticsCounselorStudents = () => import("../views/Gide/SPCM/SpcmAnalyticsCounselorStudents.vue")
const SpcmAnalyticsStudentMeetings = () => import("../views/Gide/SPCM/SpcmAnalyticsStudentMeetings.vue")
const SpcmAnalyticsCounselorsMeetings = () => import("../views/Gide/SPCM/SpcmAnalyticsCounselorsMeetings.vue")

// YjsDocs
const YjsDocsList = () => import("../views/Gide/YjsDocs/YjsDocsList.vue")

const uexccTypeList = () => import("../views/Gide/UexccType/uexccTypeList.vue")

// SocialMediaReportList
const SocialMediaReportList = () => import("../views/Gide/SocialMediaReport/SocialMediaReportList.vue")

const adminEmailTemplateList = () => import("../views/Gide/AdminEmailTemplate/AdminEmailTemplateList.vue")

const ChatMessageList = () => import("../views/Gide/MashChatMessage/ChatMessageList.vue")

// Razorpay Payments
const RazorpayPayments = () => import("../views/Gide/Razorpay/RazorpayPayments.vue")
const calendar = () => import("../components/calendar.vue")

// chatbot prompt
const ChatbotPromptEdit = () => import("../views/Gide/ChatbotPrompt/ChatbotPromptEdit.vue")
const ChatbotPromptList = () => import("../views/Gide/ChatbotPrompt/ChatbotPromptList.vue")

// wrk_agent & wrk_sub_agent
const WrkAgentList = () => import("../views/Gide/WrkAgent/WrkAgentList.vue")
const WrkSubAgentList = () => import("../views/Gide/WrkSubAgent/WrkSubAgentList.vue")
const GideContract = () => import("../views/Gide/SPCM/GideContract.vue")
const PAQ = () => import("../views/Gide/SPCM/PAQ.vue")

const childRoutes = (prop, mode) => [
  {
    path: "home",
    name: prop + ".list",
    meta: { requiresAuth: true, name: "Posts" },
    component: Posts
  },
  {
    path: "post/:post_id",
    name: prop + ".post/:postId",
    meta: { requiresAuth: true, name: "Post Detail" },
    component: PostDetail
  },
  {
    path: "clubs",
    name: prop + ".clubs",
    meta: { requiresAuth: true, name: "Clubs" },
    component: Clubs
  },
  {
    path: "/app_add",
    name: prop + ".app_add",
    meta: { auth: true, name: "Add Quiz" },
    component: AppAdd
  },
  {
    path: "event_list",
    name: prop + ".event_list",
    meta: { requiresAuth: true, name: "event List" },
    component: eventList
  },
  {
    path: "/quizBank_add/:app_id",
    name: prop + ".quizBank_add",
    meta: { auth: true, name: "Add QuizBank" },
    component: QuizBankAdd
  },
  {
    path: "/quizBank_list/:app_id",
    name: prop + ".quizBank_list",
    meta: { auth: true, name: "QuizBank List" },
    component: QuizBankList
  },
  {
    path: "/quizBank_edit/:qbk_id/:question_state?",
    name: prop + ".quizBank_edit",
    meta: { auth: true, name: "Edit QuizBank" },
    component: QuizBankEdit
  },
  {
    path: "/quiz_question_view/:qbk_id/:question_state?",
    name: prop + ".quiz_question_view",
    meta: { auth: true, name: "Quiz Question View" },
    component: QuestionQuizView
  },
  {
    path: "/thankyou",
    name: prop + ".thankyouPage",
    meta: { auth: true, name: "thankyouPage" },
    component: ThankYouPage
  },
  {
    path: "/thankyou",
    name: prop + ".thankyouPage/:code",
    meta: { auth: true, name: "thankyouPage" },
    component: ThankYouPage
  },
  {
    path: "/quiz_edit/:app_id",
    name: prop + ".quiz_edit",
    meta: { auth: true, name: "Edit Quiz" },
    component: AppEdit
  },
  {
    path: "app_chains/:app_id",
    name: prop + ".app_chains/:app_id",
    meta: { requiresAuth: true, name: "App Chains" },
    component: AppChains
  },
  {
    path: "/quiz_list",
    name: prop + ".quiz_list",
    meta: { auth: true, name: "Quiz List" },
    component: AppList
  },
  {
    path: "organisation_add",
    name: prop + ".organisation_add",
    meta: { requiresAuth: true, name: "Add Organisation" },
    component: OrganisationAdd
  },
  {
    path: "organisations/:org_type",
    name: prop + ".organisations",
    meta: { requiresAuth: true, name: "organisations" },
    component: OrganisationList
  },
  {
    path: "/organisationCourse_list/:org_id",
    name: prop + ".organisationCourse_list",
    meta: { auth: true, name: "UniversityCourse List" },
    component: UniversityCourseList
  },
  {
    path: "/organisationCourse_add",
    name: prop + ".organisationCourse_add",
    meta: { auth: true, name: "Add UniversityCourse", isAdmin: true },
    component: UniversityCourseAdd
  },
  {
    path: "/organisationCourse_edit/:cour_id",
    name: prop + ".organisationCourse_edit",
    meta: { auth: true, name: "Edit UniversityCourse", isAdmin: true },
    component: UniversityCourseEdit
  },
  {
    path: "/organisationCourse",
    name: prop + ".organisationCourse",
    meta: { auth: true, name: "Organisation Course Dashboard", isAdmin: true },
    component: UniversityCourseDashboard
  },
  {
    path: "/organisationCourse/:org_id",
    name: prop + ".organisationCourse",
    meta: { auth: true, name: "Organisation Course Dashboard", isAdmin: true },
    component: UniversityCourseDashboard
  },
  {
    path: "organisation_edit/:org_type/:org_id",
    name: prop + ".organisation_edit",
    meta: { requiresAuth: true, name: "Organisation Edit" },
    component: OrganisationEdit
  },
  {
    path: "organisations/:org_type/:org_id",
    name: prop + ".organisations",
    meta: { requiresAuth: true, name: "Organisations" },
    component: OrganisationDetails
  },
  {
    path: "/org_profile_list",
    name: prop + ".org_profile_list",
    meta: { auth: true, name: "org_profile_list" },
    component: OrgProfileList
  },
  {
    path: "course_finder",
    name: prop + ".course_finder",
    meta: { requiresAuth: true, name: "course_finder" },
    component: CourseFinder
  },
  {
    path: "dashboard",
    name: prop + ".list",
    meta: { requiresAuth: true, name: "OrgSaasDashboard" },
    component: OrgSaasDashboard
  },
  {
    path: "orgSaas_tax_documents",
    name: prop + ".list",
    meta: { requiresAuth: true, name: "OrgSaasTaxDocuments" },
    component: OrgSaasTaxDocuments
  },
  {
    path: "org_domain_validate/:org_type/:org_id",
    name: prop + ".organisations",
    meta: { requiresAuth: true, name: "OrgSaasDomainValidate" },
    component: OrgSaasDomainValidate
  },
  {
    path: "org_edit/:org_type/:org_id",
    name: prop + ".organisations",
    meta: { requiresAuth: true, name: "OrgSaasDomainValidate" },
    component: OrgSaasOrganisationEdit
  },
  {
    path: "login_preview/:org_type/:org_id",
    name: prop + ".organisations",
    meta: { requiresAuth: true, name: "OrgSaasDomainValidate" },
    component: OrgSaasLoginPagePreview
  },
  {
    path: "revenue_dashboard",
    name: prop + ".revenueDashboard",
    meta: { requiresAuth: true, name: "OrgSaasRevenueDashboard" },
    component: OrgSaasRevenueDashboard
  },
  {
    path: "redemption_dashboard",
    name: prop + ".revenueDashboard",
    meta: { requiresAuth: true, name: "OrgSaasRevenueDashboard" },
    component: OrgSaasRedemptionDashboard
  },
  {
    path: "redemption_admin_dashboard",
    name: prop + ".redemptionAdminDashboard",
    meta: { requiresAuth: true, name: "OrgSaasRedemptionAdminDashboard" },
    component: OrgSaasRedemptionAdminDashboard
  },
  {
    path: "manage_users/:org_type/:org_id",
    name: prop + ".manage_users",
    meta: { requiresAuth: true, name: "ManageUsers" },
    component: ManageUsers
  },
  {
    path: "manage_role/:org_id/:org_type",
    name: prop + ".manage_role",
    meta: { requiresAuth: true, name: "ManageRole" },
    component: ManageRoles
  },
  {
    path: "user/:user_id",
    name: prop + ".user",
    meta: { requiresAuth: true, name: "User" },
    component: UserProfile
  },
  {
    path: "/user_edit/:user_id",
    name: prop + ".user_edit",
    meta: { requiresAuth: true, name: "User Edit" },
    component: UserProfileEdit
  },
  {
    path: "club/:club_id",
    name: prop + ".club",
    meta: { requiresAuth: true, name: "Club" },
    component: ClubProfile
  },
  {
    path: "club_edit/:club_id",
    name: prop + ".club_edit",
    meta: { requiresAuth: true, name: "Club Edit" },
    component: ClubProfileEdit
  },
  {
    path: "club_create/:owner_module_obj_id",
    name: prop + ".club_create",
    meta: { requiresAuth: true, name: "Club Create" },
    component: ClubCreate
  },
  {
    path: "testseries_product_list",
    name: prop + ".testseries_product_list",
    meta: { requiresAuth: true, name: "testseries_product_list" },
    component: TSeriesProductList
  },
  {
    path: "testseries_exam_details/:pdt_id",
    name: prop + ".testseries_exam_details",
    meta: { requiresAuth: true, name: "TestPrepProductExam" },
    component: TPrepSpecificProduct
  },
  {
    path: "testseries_admin_dashboard",
    name: prop + ".testseries_admin_dashboard",
    meta: { auth: true, name: "testseries_admin_dashboard" },
    component: TprepAdminDashboard
  },
  {
    path: "testseries_notes/:spcmId",
    name: prop + ".testseries_notes",
    meta: { requiresAuth: false, name: "spcm" },
    component: SpcmView
  },
  {
    path: "tprep_session_add",
    name: prop + ".tprep_session_add",
    meta: { auth: true, name: "Add TprepSession" },
    component: TprepSessionAdd
  },
  {
    path: "tprep_session_edit/:tps_id",
    name: prop + ".tprep_session_edit",
    meta: { auth: true, name: "Edit TprepSession" },
    component: TprepSessionEdit
  },
  {
    path: "tprep_quiz_dashboard",
    name: prop + ".tprep_quiz_dashboard",
    meta: { auth: true, name: "TprepQuizDashboard" },
    component: TprepQuizDashboard
  },
  {
    path: "/tprep_batch_list",
    name: prop + ".tprep_batch_list",
    meta: { auth: true, name: "tprep_batch_list" },
    component: TprepBatchList
  },
  {
    path: "testseries_configuration",
    name: prop + ".testseries_configuration",
    meta: { auth: true, name: "TPrepSubjectModule List" },
    component: TPrepSubjectModuleList
  },
  {
    path: "subjectModule_add",
    name: prop + ".subjectModule_add",
    meta: { auth: true, name: "Add TPrepSubjectModule" },
    component: TPrepSubjectModuleAdd
  },
  {
    path: "subjectModule_edit/:subject_module_id",
    name: prop + ".subjectModule_edit",
    meta: { auth: true, name: "Edit TPrepSubjectModule" },
    component: TPrepSubjectModuleEdit
  },
  {
    path: "subject_modules/:subjId",
    name: prop + ".subject_modules",
    meta: { requiresAuth: true, name: "Home" },
    component: TPrepModuleList
  },
  {
    path: "attempt_list/:appId/:subjId",
    name: prop + ".attempt_list",
    meta: { requiresAuth: true, name: "Attempt List" },
    component: TPrepAttemptList
  },
  {
    path: "interest_list",
    name: prop + ".interest_list",
    meta: { auth: true, name: "Interest List" },
    component: InterestList
  },
  {
    path: "interest_add",
    name: prop + ".interest_add",
    meta: { auth: true, name: "Add Interest" },
    component: InterestAdd
  },
  {
    path: "interest_edit/:interest_id",
    name: prop + ".interest_edit",
    meta: { auth: true, name: "Edit Interest" },
    component: InterestEdit
  },
  {
    path: "interestCategory_list",
    name: prop + ".interestCategory_list",
    meta: { auth: true, name: "InterestCategory List" },
    component: InterestCategoryList
  },
  {
    path: "interestCategory_add",
    name: prop + ".interestCategory_add",
    meta: { auth: true, name: "Add InterestCategory" },
    component: InterestCategoryAdd
  },
  {
    path: "interestCategory_edit/:interest_cat_id",
    name: prop + ".interestCategory_edit",
    meta: { auth: true, name: "Edit InterestCategory" },
    component: InterestCategoryEdit
  },
  {
    path: "/appResult_list/:app_id",
    name: prop + ".appResult_list",
    meta: { auth: true, name: "AppResult List" },
    component: AppResultList
  },
  {
    path: "/appResult_list_fix/:app_id/:user_id",
    name: prop + ".appResult_list_fix",
    meta: { auth: true, name: "AppResult List Fix" },
    component: AppResultListFix
  },
  {
    path: "event/:event_id",
    name: prop + ".event",
    meta: { requiresAuth: true, name: "Events" },
    component: eventView
  },
  {
    path: "event_add",
    name: prop + ".event_add",
    meta: { requiresAuth: true, name: "Event Add" },
    component: eventAdd
  },
  {
    path: "event_edit/:event_id",
    name: prop + ".event_edit",
    meta: { requiresAuth: true, name: "Event Edit" },
    component: eventEdit
  },
  {
    path: "events",
    name: prop + ".events",
    meta: { requiresAuth: true, name: "Events" },
    component: Events
  },
  {
    path: "subscription_plans",
    name: prop + ".subscription_plans",
    meta: { requiresAuth: true, name: "Subscription Plans" },
    component: SubscriptionPlans
  },
  {
    path: "subscription_addOns_plans",
    name: prop + ".subscription_plans",
    meta: { requiresAuth: true, name: "Subscription Plans" },
    component: SubscriptionPlans
  },
  {
    path: "my_billing_history/:user_id",
    name: prop + ".my_billing_history",
    meta: { auth: true, name: "My Billing History" },
    component: MyBillingHistory
  },
  {
    path: "payTransactions_list",
    name: prop + ".payTransactions_list",
    meta: { auth: true, name: "PayTransactions List" },
    component: PayTransactionsListAdmin
  },
  {
    path: "payTransactions_list/:student_id",
    name: prop + ".payTransactions",
    meta: { auth: true, name: "PayTransactions" },
    component: PayTransactionsListAdmin
  },
  {
    path: "payTransactions_edit/:pay_id",
    name: prop + ".payTransactions_edit",
    meta: { auth: true, name: "Edit Pay Transactions" },
    component: PayTransactionsEdit
  },
  {
    path: "pay_gw_status",
    name: prop + ".pay_gw_status",
    meta: { auth: true, name: "Paygw Status" },
    component: PaygwStatus
  },
  {
    path: "pay_gw",
    name: prop + ".pay_gw",
    meta: { auth: true, name: "Paygw" },
    component: Paygw
  },
  {
    path: "pay_gw/:moduleType/:moduleObjId",
    name: prop + ".pay_gw",
    meta: { auth: true, name: "Paygw" },
    component: Paygw
  },
  {
    path: "razorpay_payments",
    name: prop + ".razorpay_payments",
    meta: { auth: true, name: "razorpay_payments" },
    component: RazorpayPayments
  },
  {
    path: "invoice",
    name: prop + ".invoice",
    meta: { auth: true, name: "invoice" },
    component: Invoice
  },
  {
    path: "admission_dashboard/:userId",
    name: prop + ".admission_dashboard",
    meta: { auth: true, name: "admission_dashboard" },
    component: AdmissionDashboard
  },
  {
    path: "admission_dashboard",
    name: prop + ".admission_dashboard",
    meta: { auth: true, name: "admission_dashboard" },
    component: AdmissionDashboard
  },
  {
    path: "admissionAnalyticsSchoolWise",
    name: prop + ".Admission_analytics_school_wise",
    meta: { auth: true, name: "Admission_analytics_school_wise" },
    component: AdmissionAnalyticsSchoolWise
  },
  {
    path: "Photos/:module_id/:type",
    name: prop + ".Photos",
    meta: { auth: true, name: "Photos", img: "" },
    component: Photos
  },
  {
    path: "admission/add/:orgId",
    name: prop + ".admission_add_org",
    meta: { auth: true, name: "admission_add_org" },
    component: Admission
  },
  {
    path: "admission/:admId/view",
    name: prop + ".admission_view",
    meta: { auth: true, name: "admission_view" },
    component: Admission
  },
  {
    path: "admission/:admId/edit",
    name: prop + ".admission_edit",
    meta: { auth: true, name: "admission_edit" },
    component: Admission
  },
  {
    path: "event_list",
    name: prop + ".event_list",
    meta: { auth: true, name: "eventList" },
    component: EventList
  },
  {
    path: "event_participant_dashboard/:eventId",
    name: prop + ".event_participant_report",
    meta: { auth: true, name: "event_participant_report" },
    component: EventParticipantReport
  },
  {
    path: "event_participant_dashboard/:eventId/SCH/:orgId",
    name: prop + ".event_participant_school_report",
    meta: { auth: true, name: "event_participant_school_report" },
    component: EventParticipantReport
  },
  {
    path: "event_analytic_school",
    name: prop + ".event_analytic_all_school",
    meta: { auth: true, name: "event_analytic_all_school" },
    component: EventReportSchoolWise
  },
  {
    path: "event_analytic_school/:orgId",
    name: prop + ".event_analytic_school",
    meta: { auth: true, name: "event_analytic_school" },
    component: EventReportSchoolWise
  },
  {
    path: "event_analytics_booth_checkin_report/:eventId",
    name: prop + ".event_analytics_booth_checkin_report",
    meta: { auth: true, name: "event_analytics_booth_checkin_report" },
    component: EventCheckinReport
  },
  {
    path: "SubcriptionReport",
    name: prop + ".SubscriptionReport",
    meta: { requiresAuth: false, name: "SubscriptionReport" },
    component: SubscriptionReport
  },
  {
    path: "EventCheckingForStudent",
    name: prop + ".EventCheckingForStudent",
    meta: { requiresAuth: true, name: "EventCheckingForStudent" },
    component: EventCheckingForStudent
  },
  {
    path: "followerReport",
    name: prop + ".analyticsFollowerCountReport",
    meta: { auth: true, name: "analyticsFollowerCountReport" },
    component: analyticsFollowerCountReport
  },
  {
    path: "followerReport/:orgId",
    name: prop + ".analyticsFollowerListReport",
    meta: { auth: true, name: "analyticsFollowerListReport" },
    component: analyticsFollowerListReport
  },
  {
    path: "quiz",
    name: prop + ".quiz",
    meta: { requiresAuth: true, name: "quiz" },
    component: QuizList
  },
  {
    path: "app_result_view/:appId/:userId/:showResultInfoMsg",
    name: prop + ".app_result_view",
    meta: { requiresAuth: true, name: "app_result_view" },
    component: QuizResultView
  },
  {
    path: "app_result_view_v1/:appId/:userId/:aprsId/:attemptNo",
    name: prop + ".app_result_view_v1",
    meta: { requiresAuth: true, name: "app_result_view_v1" },
    component: QuizReportCardView
  },
  {
    path: "app_result_view_all/:appId/:userId/:aprsId/:attemptNo/:showResultInfoMsg",
    name: prop + ".app_result_view_all",
    meta: { requiresAuth: true, name: "app_result_view_all" },
    component: QuizResultView
  },
  {
    path: "app_result_analyse/:appId/:gide_user_id/:aprsId",
    name: prop + ".app_result_analyse",
    meta: { requiresAuth: true, name: "app_result_analyse" },
    component: AppAnswerExplanation
  },
  {
    path: "app_result_analyse_v1/:appId/:gide_user_id/:aprsId",
    name: prop + ".app_result_analyse",
    meta: { requiresAuth: true, name: "app_result_analyse" },
    component: AnswerAnalysis
  },
  {
    path: "quiz_detail/:quizId",
    name: prop + ".quiz",
    meta: { requiresAuth: true, name: "quiz_detail" },
    component: QuizDetail
  },
  {
    path: "quiz_break/:nextQuizId",
    name: prop + ".quiz_break",
    meta: { requiresAuth: true, name: "quiz_break" },
    component: QuizBreakTimer
  },
  {
    path: "analytics",
    name: prop + ".analytics",
    meta: { requiresAuth: true, name: "analytics" },
    component: Analytics
  },
  {
    path: "game_hangman/:app_id",
    name: prop + ".hangman",
    meta: { requiresAuth: true, name: "hangman" },
    component: hangman
  },
  {
    path: "game_crossword/:app_id",
    name: prop + ".crossword",
    meta: { requiresAuth: true, name: "crossword" },
    component: crossword
  },
  {
    path: "/paq",
    name: prop + ".paq",
    meta: { name: "paq" },
    component: PAQ
  },
  {
    path: "/paq/:gide_user_id",
    name: prop + ".paq",
    meta: { name: "paq" },
    component: PAQ
  },
  {
    path: "spcm_counseling_product",
    name: prop + ".spcmproduct",
    meta: { auth: true, name: "SpcmProduct" },
    component: SpcmProduct
  },
  {
    path: "spcm/:spcmId",
    name: prop + ".spcm",
    meta: { requiresAuth: true, name: "spcm" },
    component: SpcmView
  },
  {
    path: "spcm1/:spcmId",
    name: prop + ".spcm",
    meta: { requiresAuth: true, name: "spcm" },
    component: SpcmView1
  },
  {
    path: "spcm_counseling_dashboard",
    name: prop + ".spcm_counseling_dashboard",
    meta: { requiresAuth: true, name: "spcm_counseling_dashboard" },
    component: SpcmList
  },
  {
    path: "spcm_analytics_case_summary",
    name: prop + ".spcm_analytics_case_summary",
    meta: { requiresAuth: true, name: "spcm_analytics_case_summary" },
    component: SpcmAnalyticsCaseSummary
  },
  {
    path: "spcm_analytics_counselor_students/:counselor_id",
    name: prop + ".spcm_analytics_counselor_students",
    meta: { requiresAuth: true, name: "spcm_analytics_counselor_students" },
    component: SpcmAnalyticsCounselorStudents
  },
  {
    path: "spcm_analytics_student_meetings/:spcmId",
    name: prop + ".spcm_analytics_student_meetings",
    meta: { requiresAuth: true, name: "spcm_analytics_student_meetings" },
    component: SpcmAnalyticsStudentMeetings
  },
  {
    path: "spcm_analytics_counselor_meetings/:counselor_id",
    name: prop + ".spcm_analytics_counselor_meetings",
    meta: { requiresAuth: true, name: "spcm_analytics_counselor_meetings" },
    component: SpcmAnalyticsCounselorsMeetings
  },
  {
    path: "spcm_counseling_dashboard_v1",
    name: prop + ".spcm_counseling_dashboard_v1",
    meta: { requiresAuth: true, name: "spcm_counseling_dashboard_v1" },
    component: SpcmListv1
  },
  {
    path: "/spcm_univ_list",
    name: prop + ".SpcmUnivList",
    meta: { auth: true, name: "SpcmUnivList" },
    component: SpcmUnivList
  },
  {
    path: "/spcm_counselor_add",
    name: prop + ".spcm_counselor_add",
    meta: { auth: true, name: "spcm_counselor_add" },
    component: SpcmCounsellorAdd
  },
  {
    path: "/spcm_counselor_edit/:spcm_counselor_id",
    name: prop + ".spcm_counselor_edit",
    meta: { auth: true, name: "spcm_counselor_edit" },
    component: SpcmCounsellorEdit
  },
  {
    path: "/spcm_counseling_team",
    name: prop + ".spcm_counseling_team",
    meta: { auth: true, name: "spcm_counseling_team" },
    component: SpcmStudentCounsellorTeam
  },
  {
    path: "/spcm_manage_team/:spcm_id",
    name: prop + ".spcm_manage_team",
    meta: { auth: true, name: "spcm_manage_team" },
    component: SpcmManageTeam
  },
  {
    path: "/spcmCalendar_list/:user_id",
    name: prop + ".spcmCalendar_list",
    meta: { auth: true, name: "SpcmCalender List" },
    component: SpcmCalenderList
  },
  {
    path: "/spcmCalender_add",
    name: prop + ".spcmCalender_add",
    meta: { auth: true, name: "SpcmCalender Add" },
    component: SpcmCalenderAdd
  },
  {
    path: "/spcmCalendar_edit/:spcm_calendar_id",
    name: prop + ".spcmCalendar_edit",
    meta: { auth: true, name: "Edit SpcmCalender" },
    component: SpcmCalenderEdit
  },
  {
    path: "/spcmCalendarCategory_list",
    name: prop + ".spcmCalendarCategory_list",
    meta: { auth: true, name: "spcmCalendarCategory_list" },
    component: SpcmCalendarCategoryList
  },
  {
    path: "/spcm_milestones_list",
    name: prop + ".spcm_milestones_list",
    meta: { auth: true, name: "Spcm_milestones List" },
    component: spcmMilestonesList
  },
  {
    path: "/spcm_milestones_add",
    name: prop + ".spcm_milestones_add",
    meta: { auth: true, name: "Add Spcm_milestones" },
    component: spcmMilestonesAdd
  },
  {
    path: "/spcm_milestones_edit/:ms_id",
    name: prop + ".spcm_milestones_edit",
    meta: { auth: true, name: "Edit Spcm_milestones" },
    component: spcmMilestonesEdit
  },
  {
    path: "/spcm_essay_editor/:yjsdocsId",
    name: prop + ".spcm_essay_editor",
    meta: { auth: true, name: "Edit Spcm Essays" },
    component: SpcmEssayEditor
  },
  {
    path: "analytics_tracker_list",
    name: prop + ".analytics_tracker_list",
    meta: { auth: true, name: "analyticsTrackerList" },
    component: analyticsTrackerList
  },
  {
    path: "click_analytics",
    name: prop + ".click_analytics",
    meta: { auth: true, name: "clickAnalytics" },
    component: clickAnalytics
  },
  {
    path: "/custom_report_list",
    name: prop + ".custom_report_list",
    meta: { auth: true, name: "Custom Report List" },
    component: CustomReportList
  },
  {
    path: "orgAccountDashboard",
    name: prop + ".orgAccountDashboard",
    meta: { auth: true, name: "orgAccountDashboard" },
    component: orgAccountDashboard
  },
  {
    path: "org_morderation",
    name: prop + ".org_morderation",
    meta: { auth: true, name: "org_morderation" },
    component: OrgModeration
  },
  {
    path: "/invite",
    name: prop + ".invite",
    meta: { auth: true, name: "Invite User" },
    component: InviteUser
  },
  {
    path: "/invitev1",
    name: prop + ".invitev1",
    meta: { auth: true, name: "invitev1" },
    component: InviteUserV1
  },
  {
    path: "gpath_home/:pdt_id",
    name: prop + ".gpath_home",
    meta: { auth: true, name: "gpath_home" },
    component: GPathDashboardV1
  },
  {
    path: "gpaths",
    name: prop + ".gpath_product_list",
    meta: { auth: true, name: "gpath_product_list" },
    component: GPathProductList
  },
  {
    path: "gpath_product_list",
    name: prop + ".gpath_product_list",
    meta: { auth: true, name: "gpath_product_list" },
    component: GPathProductList
  },
  {
    path: "gpaths/:pdt_id",
    name: prop + ".gpath",
    meta: { auth: true, name: "gpath" },
    component: GPathProductPage
  },
  {
    path: "gpath_report_generate/:pdt_id",
    name: prop + ".gpath_report_generate",
    meta: { auth: true, name: "gpath_report_generate" },
    component: GPathReportGenerate
  },
  {
    path: "/gpath_session_list",
    name: prop + ".gpath_session_list",
    meta: { auth: true, name: "GPathSession List" },
    component: GPathSessionList
  },
  {
    path: "/gpath_config_list",
    name: prop + ".gpath_config_list",
    meta: { auth: true, name: "GPath ConfigList List" },
    component: GPathConfigList
  },
  {
    path: "/gpath_session_list/:user_id",
    name: prop + ".gpath_session_list",
    meta: { auth: true, name: "GPathSession List" },
    component: GPathSessionList
  },
  {
    path: "/gpath_school_dashboard/:org_id",
    name: prop + ".gpath_school_dashboard",
    meta: { auth: true, name: "GPathSchoolDashboard" },
    component: GPathSchoolDashboard
  },
  {
    path: "/affiliate_codes_dashboard",
    name: prop + ".affiliate_codes_dashboard",
    meta: { auth: true, name: "GPathSession Affiliates" },
    component: GPathSessionAffiliateList
  },
  {
    path: "/gpath_career_list",
    name: prop + ".gpath_career_list",
    meta: { auth: true, name: "GPathCareer List" },
    component: GPathCareerList
  },
  {
    path: "/gpath_career_add",
    name: prop + ".gpath_career_add",
    meta: { auth: true, name: "Add GPath Career" },
    component: GPathCareerAdd
  },
  {
    path: "/gpath_career_edit/:gpc_id",
    name: prop + ".gpath_career_edit",
    meta: { auth: true, name: "Edit GPath Career" },
    component: GPathCareerEdit
  },
  {
    path: "/gpath_career_type_list",
    name: prop + ".gpath_career_type_list",
    meta: { auth: true, name: "gpath_career_type_list" },
    component: GPathCareerTypeList
  },
  {
    path: "/gpath_career_type_list/:name",
    name: prop + ".gpath_career_type_list",
    meta: { auth: true, name: "gpath_career_type_list" },
    component: GPathCareerTypeList
  },
  {
    path: "/career_role_list",
    name: prop + ".career_role_list",
    meta: { auth: true, name: "career_role_list" },
    component: GPathCareerRoleList
  },
  {
    path: "/gpath_career_role_detail/:gpct_id",
    name: prop + ".gpath_career_role_detail",
    meta: { auth: true, name: "GPathCareerRoleDetail" },
    component: GPathCareerRoleDetail
  },
  {
    path: "/gpath_aptitude_list",
    name: prop + ".gpath_aptitude_list",
    meta: { auth: true, name: "GPathAptitude List" },
    component: GPathAptitudeList
  },
  {
    path: "/gpath_aptitude_add",
    name: prop + ".gpath_aptitude_add",
    meta: { auth: true, name: "Add GPathAptitude" },
    component: GPathAptitudeAdd
  },
  {
    path: "/gpath_aptitude_edit/:gpa_id",
    name: prop + ".gpath_aptitude_edit",
    meta: { auth: true, name: "Edit GPathAptitude" },
    component: GPathAptitudeEdit
  },
  {
    path: "/gpath_career_inter_list",
    name: prop + ".gpath_career_inter_list",
    meta: { auth: true, name: "GPathCareerInter List" },
    component: GPathCareerInterList
  },
  {
    path: "/gpath_career_inter_add",
    name: prop + ".gpath_career_inter_add",
    meta: { auth: true, name: "Add GPathCareerInter" },
    component: GPathCareerInterAdd
  },
  {
    path: "/gpath_career_inter_edit/:gpci_id",
    name: prop + ".gpath_career_inter_edit",
    meta: { auth: true, name: "Edit GPathCareerInter" },
    component: GPathCareerInterEdit
  },
  {
    path: "/gpath_skill_list",
    name: prop + ".gpath_skill_list",
    meta: { auth: true, name: "GPathSkill List" },
    component: GPathSkillList
  },
  {
    path: "/gpath_skill_add",
    name: prop + ".gpath_skill_add",
    meta: { auth: true, name: "Add GPathSkill" },
    component: GPathSkillAdd
  },
  {
    path: "/gpath_skill_edit/:gps_id",
    name: prop + ".gpath_skill_edit",
    meta: { auth: true, name: "Edit GPathSkill" },
    component: GPathSkillEdit
  },
  {
    path: "/gpath_career_univ_list",
    name: prop + ".gpath_career_univ_list",
    meta: { auth: true, name: "GPathCareerUniv List" },
    component: GPathCareerUnivList
  },
  {
    path: "/gpath_career_univ_add",
    name: prop + ".gpath_career_univ_add",
    meta: { auth: true, name: "Add GPathCareerUniv" },
    component: GPathCareerUnivAdd
  },
  {
    path: "/gpath_career_univ_edit/:gcu_id",
    name: prop + ".gpath_career_univ_edit",
    meta: { auth: true, name: "Edit GPathCareerUniv" },
    component: GPathCareerUnivEdit
  },
  {
    path: "/gpathRoadmap_list",
    name: prop + ".gpathRoadmap_list",
    meta: { auth: true, name: "GpathRoadmap List" },
    component: GpathRoadmapList
  },
  {
    path: "/gpathRoadmap_add",
    name: prop + ".gpathRoadmap_add",
    meta: { auth: true, name: "Add GpathRoadmap" },
    component: GpathRoadmapAdd
  },
  {
    path: "/gpathRoadmap_edit/:grmap_id",
    name: prop + ".gpathRoadmap_edit",
    meta: { auth: true, name: "Edit GpathRoadmap" },
    component: GpathRoadmapEdit
  },
  {
    path: "/gpathRoadmapExtra_list",
    name: prop + ".gpathRoadmapExtra_list",
    meta: { auth: true, name: "GPathrRoadmapExtra List" },
    component: GPathrRoadmapExtraList
  },
  {
    path: "/gpathRoadmapExtra_add",
    name: prop + ".gpathRoadmapExtra_add",
    meta: { auth: true, name: "Add GPathrRoadmapExtra" },
    component: GPathrRoadmapExtraAdd
  },
  {
    path: "/gpathRoadmapExtra_edit/:gprme_id",
    name: prop + ".gpathRoadmapExtra_edit",
    meta: { auth: true, name: "Edit GPathrRoadmapExtra" },
    component: GPathrRoadmapExtraEdit
  },
  {
    path: "/gpath_career_univ_scholarship_list",
    name: prop + ".gpath_career_univ_scholarship_list",
    meta: { auth: true, name: "GPathCareerUnivScholarship List" },
    component: GPathCareerUnivScholarshipList
  },
  {
    path: "/gpath_career_univ_scholarship_add",
    name: prop + ".gpath_career_univ_scholarship_add",
    meta: { auth: true, name: "Add GPathCareerUnivScholarship" },
    component: GPathCareerUnivScholarshipAdd
  },
  {
    path: "/gpath_career_univ_scholarship_edit/:gcus_id",
    name: prop + ".gpath_career_univ_scholarship_edit",
    meta: { auth: true, name: "Edit GPathCareerUnivScholarship" },
    component: GPathCareerUnivScholarshipEdit
  },
  {
    path: "/gpath_aptitude_reco_list",
    name: prop + ".gpath_aptitude_reco_list",
    meta: { auth: true, name: "Gpath_aptitude_reco List" },
    component: gpathAptitudeRecoList
  },
  {
    path: "/gpath_aptitude_reco_add",
    name: prop + ".gpath_aptitude_reco_add",
    meta: { auth: true, name: "Add Gpath_aptitude_reco" },
    component: gpathAptitudeRecoAdd
  },
  {
    path: "/gpath_aptitude_reco_edit/:gpar_id",
    name: prop + ".gpath_aptitude_reco_edit",
    meta: { auth: true, name: "Edit Gpath_aptitude_reco" },
    component: gpathAptitudeRecoEdit
  },
  {
    path: "/gpath_skill_reco_list",
    name: prop + ".gpath_skill_reco_list",
    meta: { auth: true, name: "Gpath_skill_reco List" },
    component: gpathSkillRecoList
  },
  {
    path: "/gpath_skill_reco_add",
    name: prop + ".gpath_skill_reco_add",
    meta: { auth: true, name: "Add Gpath_skill_reco" },
    component: gpathSkillRecoAdd
  },
  {
    path: "/gpath_skill_reco_edit/:gpsr_id",
    name: prop + ".gpath_skill_reco_edit",
    meta: { auth: true, name: "Edit Gpath_skill_reco" },
    component: gpathSkillRecoEdit
  },
  {
    path: "/gpath_company_reco_list",
    name: prop + ".gpath_company_reco_list",
    meta: { auth: true, name: "gpath_company_reco_list" },
    component: GpathCompanyList
  },
  {
    path: "/resume_builder",
    name: prop + ".resume",
    meta: { auth: true, name: "Resume" },
    component: ResumeBuild
  },
  {
    path: "/resume_view",
    name: prop + ".resume",
    meta: { auth: true, name: "Resume" },
    component: Resume
  },
  {
    path: "/chat_invite",
    name: prop + ".chat_invite",
    meta: { auth: true, name: "ChatInvite", requiresAuth: true },
    component: MeshInvite
  },
  {
    path: "/chat_deeplink",
    name: prop + ".chat_deeplink",
    meta: { auth: true, name: "ChatInvite", requiresAuth: true },
    component: MeshDeepLink
  },
  {
    path: "/config_menu_list/:config_menu_type",
    name: prop + ".config_menu_list",
    meta: { auth: true, name: "ConfigMenu List" },
    component: ConfigMenuList
  },
  {
    path: "/config_menu_add",
    name: prop + ".config_menu_add",
    meta: { auth: true, name: "Add ConfigMenu" },
    component: ConfigMenuAdd
  },
  {
    path: "/config_menu_edit/:acm_id",
    name: prop + ".config_menu_edit",
    meta: { auth: true, name: "Edit ConfigMenu" },
    component: ConfigMenuEdit
  },
  {
    path: "user_list",
    name: prop + ".user_list",
    meta: { auth: true, name: "User List", isAdmin: true },
    component: UserList
  },
  {
    path: "user_search/:user_data",
    name: prop + ".user_search",
    meta: { auth: true, name: "User Search" },
    component: UserSearch
  },
  {
    path: "user_search",
    name: prop + ".user_search",
    meta: { auth: true, name: "User Search" },
    component: UserSearch
  },
  {
    path: "subscriptionPlan_list",
    name: prop + ".subscriptionPlan_list",
    meta: { auth: true, name: "Subscription List", isAdmin: true },
    component: SubscriptionPlanList
  },
  {
    path: "subscriptionPlan_list/:subsPlanId",
    name: prop + ".subscriptionPlan_list",
    meta: { auth: true, name: "Subscription List", isAdmin: true },
    component: SubscriptionPlanList
  },
  {
    path: "subscriptionPlan_add",
    name: prop + ".subscriptionPlan_add",
    meta: { auth: true, name: "Add Subscription", isAdmin: true },
    component: SubscriptionPlanAdd
  },
  {
    path: "subscriptionPlan_edit/:subs_plan_id",
    name: prop + ".subscriptionPlan_edit",
    meta: { auth: true, name: "Edit Subscription", isAdmin: true },
    component: SubscriptionPlanEdit
  },
  {
    path: "subscription_list",
    name: prop + ".subscription_list",
    meta: { auth: true, name: "Subscription List" },
    component: SubscriptionList
  },
  {
    path: "subscription_list/:student_id",
    name: prop + ".subscription",
    meta: { auth: true, name: "Subscription" },
    component: SubscriptionList
  },
  {
    path: "subscription_add",
    name: prop + ".subscription_add",
    meta: { auth: true, name: "Add Subscription" },
    component: SubscriptionAdd
  },
  {
    path: "subscription_edit/:subs_id",
    name: prop + ".subscription_edit",
    meta: { auth: true, name: "Edit Subscription" },
    component: SubscriptionEdit
  },
  {
    path: "contactus_list",
    name: prop + ".contactus_list",
    meta: { auth: true, name: "contactus_list" },
    component: ContactUsList
  },
  {
    path: "user_reg_lead_list",
    name: prop + ".user_reg_lead_list",
    meta: { auth: true, name: "user_reg_lead_list" },
    component: contactusB2BList
  },
  {
    path: "admin_notification_list",
    name: prop + ".admin_notification_list",
    meta: { auth: true, name: "AdminNotificationList" },
    component: AdminNotificationList
  },
  {
    path: "admin_notification_add",
    name: prop + ".admin_notification_add",
    meta: { auth: true, name: "AdminNotificationAdd" },
    component: AdminNotificationAdd
  },
  {
    path: "admin_notification_edit/:notification_id",
    name: prop + ".admin_notification_edit",
    meta: { auth: true, name: "AdminNotificationEdit" },
    component: AdminNotificationEdit
  },
  {
    path: "faq_list",
    name: prop + ".faq_list",
    meta: { auth: true, name: "faq_list" },
    component: AdminFaqList
  }, // Used for all FAQs after login
  {
    path: "faq_list/:faqModule",
    name: prop + ".faq_list",
    meta: { auth: true, name: "faq_list" },
    component: AdminFaqList
  }, // Used for module specific FAQs after login
  {
    path: "faq_list_dashboard",
    name: prop + ".faq_list_dashboard",
    meta: { auth: true, name: "faq_list_dashboard" },
    component: AdminFaqList
  }, // FAQ admin dashboard
  {
    path: "faq_add",
    name: prop + ".faq_add",
    meta: { auth: true, name: "faq_add" },
    component: AdminFaqAdd
  },
  {
    path: "faq_edit/:faq_id",
    name: prop + ".faq_edit",
    meta: { auth: true, name: "faq_edit" },
    component: AdminFaqEdit
  },
  {
    path: "chatbot_data_src_list",
    name: prop + ".chatbot_data_src_list",
    meta: { auth: true, name: "ChatBotDataSrc List" },
    component: ChatBotDataSrcList
  },
  {
    path: "chatbot_data_src_add",
    name: prop + ".chatbot_data_src_add",
    meta: { auth: true, name: "Add ChatBotDataSrc" },
    component: ChatBotDataSrcAdd
  },
  {
    path: "chatbot_data_src_edit/:cbds_id",
    name: prop + ".chatbot_data_src_edit",
    meta: { auth: true, name: "Edit ChatBotDataSrc" },
    component: ChatBotDataSrcEdit
  },
  {
    path: "chatbot_llm_list",
    name: prop + ".chatbot_llm_list",
    meta: { auth: true, name: "ChatBotLLM List" },
    component: ChatBotLLMList
  },
  {
    path: "chatbot_llm_add",
    name: prop + ".chatbot_llm_add",
    meta: { auth: true, name: "Add ChatBotLLM" },
    component: ChatBotLLMAdd
  },
  {
    path: "chatbot_llm_edit/:cbllm_id",
    name: prop + ".chatbot_llm_edit",
    meta: { auth: true, name: "Edit ChatBotLLM" },
    component: ChatBotLLMEdit
  },
  {
    path: "/customFormFields_list",
    name: prop + ".customFormFields_list",
    meta: { auth: true, name: "CustomFormFields List" },
    component: CustomFormFieldsList
  },
  {
    path: "/customFormFields_add",
    name: prop + ".customFormFields_add",
    meta: { auth: true, name: "Add CustomFormFields" },
    component: CustomFormFieldsAdd
  },
  {
    path: "/customFormFields_edit/:cff_id",
    name: prop + ".customFormFields_edit",
    meta: { auth: true, name: "Edit CustomFormFields" },
    component: CustomFormFieldsEdit
  },
  {
    path: "/customFormBuild_list",
    name: prop + ".customFormFields_edit",
    meta: { auth: true, name: "Edit CustomFormFields" },
    component: CustomFormBuildList
  },
  {
    path: "/customFormBuild_edit/:cfb_id",
    name: prop + ".customFormBuild_edit",
    meta: { auth: true, name: "Edit customFormBuild" },
    component: customFormBuildEdit
  },
  {
    path: "/resource/:name",
    name: prop + ".ResourceScholarships",
    meta: { auth: true, name: "ResourceScholarships" },
    component: ResourceScholarships
  },
  {
    path: "/resource_gidepreneur",
    name: prop + ".ResourceGidePreneur",
    meta: { auth: true, name: "ResourceGidePreneur" },
    component: ResourceGidePreneur
  },
  {
    path: "/udf_action_list",
    name: prop + ".udf_action_list",
    meta: { auth: true, name: "Udf_action List" },
    component: UdfActionList
  },
  {
    path: "/udf_action_add",
    name: prop + ".udf_action_add",
    meta: { auth: true, name: "Add Udf_action" },
    component: UdfActionAdd
  },
  {
    path: "/udf_action_edit/:action_id",
    name: prop + ".udf_action_edit",
    meta: { auth: true, name: "Edit Udf_action" },
    component: UdfActionEdit
  },
  {
    path: "/userbilldetails_list",
    name: prop + ".userbilldetails_list",
    meta: { auth: true, name: "UserBillDetails List" },
    component: UserBillDetailsList
  },
  {
    path: "/userbilldetails_add",
    name: prop + ".userbilldetails_add",
    meta: { auth: true, name: "Add UserBillDetails" },
    component: UserBillDetailsAdd
  },
  {
    path: "/userbilldetails_edit/:ubd_id",
    name: prop + ".userbilldetails_edit",
    meta: { auth: true, name: "Edit UserBillDetails" },
    component: UserBillDetailsEdit
  },
  {
    path: "/FireFliesList",
    name: prop + ".spcmFireFliesList",
    meta: { auth: true, name: "SPCMFireFlies List" },
    component: SPCMFireFliesList
  },
  {
    path: "/FireFliesView/:spcmff_id",
    name: prop + ".spcmFireFliesView",
    meta: { auth: true, name: "SPCMFireFlies View" },
    component: SPCMFireFliesView
  },
  {
    path: "/yjsdocs_list",
    name: prop + ".yjsdocs_list",
    meta: { auth: true, name: "yjsdocs_list" },
    component: YjsDocsList
  },
  {
    path: "/blog_list",
    name: prop + ".blog_list",
    meta: { auth: true, name: "blog_list" },
    component: blogList
  },
  {
    path: "/blog_edit/:blogId",
    name: prop + ".blog_list",
    meta: { auth: true, name: "blog_list" },
    component: blogEdit
  },
  {
    path: "/uexcc_type_list",
    name: prop + ".uexcc_type_list",
    meta: { auth: true, name: "uexcc_type List" },
    component: uexccTypeList
  },
  {
    path: "/blog_view/:blogId",
    name: prop + ".blog_view",
    meta: { auth: true, name: "blog_view" },
    component: blogView
  },
  {
    path: "socialmediareport_list",
    name: prop + ".socialmediareport_list",
    meta: { requiresAuth: true, name: "social media report" },
    component: SocialMediaReportList
  },
  {
    path: "socialmediareport_list/:org_id",
    name: prop + ".socialmediareport_list",
    meta: { requiresAuth: true, name: "social media report" },
    component: SocialMediaReportList
  },
  {
    path: "email_template_list",
    name: prop + ".email_template_list",
    meta: { auth: true, name: "email_template_list" },
    component: adminEmailTemplateList
  },
  {
    path: "/chat_message_list",
    name: prop + ".chat_message_list",
    meta: { auth: true, name: "chat_message_list" },
    component: ChatMessageList
  },
  {
    path: "chatbot_prompt_list",
    name: prop + ".chatbot_prompt_list",
    meta: { auth: true, name: "chatbot_prompt_list" },
    component: ChatbotPromptList
  },
  {
    path: "/chatbot_prompt_edit/:prompt_id",
    name: prop + ".chatbot_prompt_edit",
    meta: { auth: true, name: "chatbot_prompt_edit" },
    component: ChatbotPromptEdit
  },
  {
    path: "/wrk_agent_list",
    name: prop + ".wrk_agent_list",
    meta: { auth: true, name: "Work Agent List" },
    component: WrkAgentList
  },
  {
    path: "/wrk_sub_agent_list/:agent_id",
    name: prop + ".wrk_sub_agent_list",
    meta: { auth: true, name: "Work Sub Agent List" },
    component: WrkSubAgentList
  },
  {
    path: "/gidecontract/:gide_user_id/:blog_id",
    name: prop + ".gide_contract",
    meta: { auth: true, name: "gide contract" },
    component: GideContract
  }
]

const contentChildRoutes = (prop, mode) => [
  {
    path: "post/:post_id",
    name: prop + ".postContent",
    meta: { requiresAuth: false, name: "PostContent" },
    component: PostContent
  },
  {
    path: "Tnc",
    name: prop + ".Tnc",
    meta: { name: "Tnc" },
    component: Tnc
  },
  {
    path: "PrivacyPolicy",
    name: prop + ".PrivacyPolicy",
    meta: { name: "PrivacyPolicy" },
    component: PrivacyPolicy
  }
]

const quizChildRoutes = (prop, mode) => [
  {
    path: "quiz/:appId",
    name: prop + ".quiz",
    meta: { requiresAuth: true, name: "quiz" },
    component: QuestionQuizFullPage
  },
  {
    path: "quizv1/:appId",
    name: prop + ".quizv1",
    meta: { requiresAuth: true, name: "quizv1" },
    component: QuestionQuizFullPageV1
  }
]

const publicChildRoutes = (prop, mode) => [
  {
    path: "GideEvents",
    name: prop + ".GideEvents",
    meta: { requiresAuth: false, name: "GideEvents" },
    component: GideEventList
  },
  {
    path: "GideEvent/:eventId",
    name: prop + ".GideEvent",
    meta: { requiresAuth: false, name: "GideEvent" },
    component: GideEventView
  },
  {
    path: "GideUniEvents",
    name: prop + ".GideEvents",
    meta: { requiresAuth: false, name: "GideUniEvents" },
    component: GideEventList
  },
  {
    path: "GideUniEvent/:eventId",
    name: prop + ".GideEvent",
    meta: { requiresAuth: false, name: "GideUniEvent" },
    component: GideEventView
  },
  {
    path: "GideViewCurrentEvent/:module_id",
    name: prop + ".GideViewCurrentEvent",
    meta: { requiresAuth: false, name: "GideViewCurrentEvent" },
    component: GideViewCurrentEvent
  },
  {
    path: "/affiliate/:eventId",
    name: prop + ".affiliate",
    meta: { auth: true, name: "List Affiliates" },
    component: AffiliateList
  },
  {
    path: "gid/:user_id",
    name: prop + ".user",
    meta: { name: "User" },
    component: UserPublicProfile
  }
]

const webflowRoutes = (prop, mode) => [
  {
    path: "confirmation",
    name: prop + ".confirmation",
    meta: { name: "confirmation" },
    component: Confirmation
  },
  {
    path: "confirmation/:code/:pay_tid",
    name: prop + ".confirmation/:code",
    meta: { name: "confirmation" },
    component: Confirmation
  },
  {
    path: "register",
    name: prop + ".register",
    meta: { requiresVisitors: true, name: "Register" },
    component: RegisterV1
  },
  {
    path: "login",
    name: prop + ".login",
    meta: { requiresVisitors: true, name: "Login" },
    component: LoginV1
  },
  {
    path: "quick-profile",
    name: prop + ".QuickProfile",
    meta: { requiresVisitors: true, name: "QuickProfile" },
    component: QuickProfileV1
  },
  {
    path: "forgotPassword",
    name: prop + ".forgotPassword",
    meta: { requiresVisitors: true, name: "forgotPassword" },
    component: ForgotPasswordV1
  },
  {
    path: "resetPassword",
    name: prop + ".resetPassword",
    meta: { requiresVisitors: true, name: "resetPassword" },
    component: ResetPasswordV1
  },
  {
    path: "activate",
    name: prop + ".activate",
    meta: { requiresVisitors: true, name: "Activate" },
    component: ActivateV1
  },
  {
    path: "ContactUsV1",
    name: prop + ".ContactUsV1",
    meta: { name: "ContactUsV1" },
    component: WebFlowContactUsStudentsAdd
  },
  {
    path: "Activity/:activityId",
    name: prop + ".Activity",
    meta: { name: "Activity" },
    component: CustomActivityForm
  },
  {
    path: "calendar",
    name: prop + ".calendar",
    meta: { name: "calendar" },
    component: calendar
  }
]

const webflowRoutesHeaderFooter = (prop, mode) => [
  {
    path: "ContactUs",
    name: prop + ".ContactUsV2",
    meta: { name: "ContactUsV2" },
    component: WebFlowContactUsStudentsAddV2
  },
  {
    path: "ContactUsV2",
    name: prop + ".ContactUsV2",
    meta: { name: "ContactUsV2" },
    component: WebFlowContactUsStudentsAddV2
  },
  {
    path: "GideEventsV1",
    name: prop + ".GideEvents",
    meta: { requiresAuth: false, name: "GideEvents" },
    component: GideEventList
  },
  {
    path: "GideEventV1/:eventId",
    name: prop + ".GideEvent",
    meta: { requiresAuth: false, name: "GideEvent" },
    component: GideEventView
  },
  {
    path: "faqs",
    name: prop + ".faq_list",
    meta: { name: "faq_list" },
    component: AdminFaqList
  }, // Used public page to display all FAQs
  {
    path: "blogs",
    name: prop + ".gide_blog_list",
    meta: { requiresAuth: false, name: "gide_blog_list" },
    component: blogPublicList
  },
  {
    path: "/blog/:blogId",
    name: prop + ".blog_view",
    meta: { requiresAuth: false, name: "blog_view" },
    component: blogView
  },
  {
    path: "error",
    name: prop + ".error",
    meta: { name: "ErrorPage" },
    component: ErrorPage
  },
  {
    path: "error/:err",
    name: prop + ".error",
    meta: { name: "ErrorPage" },
    component: ErrorPage
  },
  {
    path: "university_profile_public/:org_type/:org_id",
    name: prop + ".organisations",
    meta: { name: "organisations" },
    component: OrganisationPublicProfile
  }
]

const blankLayoutRouter = (prop, mode) => [
  {
    path: "ContactUs",
    name: prop + ".ContactUsV2",
    meta: { name: "ContactUsV2" },
    component: WebFlowContactUsStudentsAddV2
  },
  {
    path: "WebContactUs",
    name: prop + ".ContactUsV2",
    meta: { name: "ContactUsV2" },
    component: WebFlowContactUsStudentsAddV2,
    // Rendered full-width, no left sidebar column — this route is embedded
    // as an iframe modal (see gide-website FormModalComponent).
    props: { propPublicContactUs: "true", propOpenedInModal: true }
  },
  {
    path: "GideEventsV1",
    name: prop + ".GideEvents",
    meta: { requiresAuth: false, name: "GideEvents" },
    component: GideEventList
  },
  {
    path: "GideEventV1/:eventId",
    name: prop + ".GideEvent",
    meta: { requiresAuth: false, name: "GideEvent" },
    component: GideEventView
  }
]

const routes = [
  {
    path: "/content",
    name: "content",
    component: ContentLayout,
    children: contentChildRoutes("content")
  },
  {
    path: "/assessment",
    name: "assessment",
    component: QuizLayout,
    children: quizChildRoutes("quiz")
  },
  {
    path: "/public",
    name: "public",
    component: ContentLayout,
    children: publicChildRoutes("public")
  },
  {
    path: "/",
    name: "gide",
    component: GideLayout,
    children: childRoutes("gide")
  },
  {
    path: "/",
    name: "webflow",
    component: WebflowLayout,
    children: webflowRoutes("webflow")
  },
  {
    path: "/",
    name: "webflowHeaderFooter",
    component: WebflowLayoutHeaderFooter,
    children: webflowRoutesHeaderFooter("webflowHeaderFooter")
  },
  {
    path: "/gidewebsite2",
    name: "gidewebsite2",
    component: BlankLayout,
    children: blankLayoutRouter("gideWebsite")
  }
]

export default routes
